import script from "./ViolationDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./ViolationDetailsModal.vue?vue&type=style&index=0&id=7af6d9a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af6d9a8"]])

export default __exports__